/* eslint-disable import/no-cycle */
import {computed, decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {Hierarchy} from '../models/hierarchy';

export class HierarchyStore extends EntityStore {
  hierarchies = [];

  constructor(rootStore) {
    super(rootStore, 'hierarchies', Api.hierarchy, Hierarchy);
  }

  get hierarchyTree() {
    return Hierarchy.buildTreeAndSort(this.hierarchies.toJS());
  }

  get hierarchyRoot() {
    return this.hierarchies.find((hierarchy) => hierarchy.parentId === null);
  }

  getPathIds(hierarchyId) {
    const hierarchy = this.getById(hierarchyId);
    if (hierarchy?.parentId) {
      return [
        hierarchyId,
        ...this.getPathIds(hierarchy.parentId),
      ];
    }
    return [hierarchyId];
  }

  getChildren(hierarchyId) {
    return this.hierarchies.filter((hierarchy) => hierarchy.parentId === hierarchyId);
  }
}

decorate(HierarchyStore, {
  hierarchies: observable,
  hierarchyTree: computed,
  hierarchyRoot: computed,
});
